export const SLICE_ORDER = 'SLICE_ORDER'

export const CREATE_ORDER = `${SLICE_ORDER}/createOrder`
export const ORDER_HISTORIES = `${SLICE_ORDER}/orderHistories`
